import { useState } from "react";
import { Modal, Select, DatePicker, TimePicker } from "antd";
import CustomSelect from "../../components/common/CustomSelect.js";
import closeIcon from "../../assets/images/common/close.svg";
import ClockIcon from "../../assets/images/doctor/ClockIcon.svg";
import "../../assets/css/appointments/modal.scss";
import Location from "../../atoms/Location/Location.js";

const AddAppointmentModal = ({ open, onClose }) => {

  const handleSubmit = (event) => {
    event.preventDefault();
  }

  const [isRegistered, setIsRegistered] = useState(false);

  // const [isOpen, setIsOpen] = useState(false);
  // const toggleDatePicker = () => setIsOpen(!isOpen);
  // const [selectedDate, setSelectedDate] = useState("");

  // const handleDateChange = (date) => {
  //   // Format the date as desired
  //   const formattedDate = `${date.getFullYear()}-${
  //     date.getMonth() + 1
  //   }-${date.getDate()}`;
  //   setSelectedDate(formattedDate);
  // };

  // const onChange = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  const handleCancel = () => {
    onClose();
  };

  const doctors = [
    {
      value: "Dr. Drake Boeson",
      label: "Dr. Drake Boeson",
    },
    {
      value: "Dr. Keegan Dach",
      label: "Dr. Keegan Dach",
    },
    {
      value: "Dr. Delaney Mangino",
      label: "Dr. Delaney Mangino",
    },
    {
      value: "Dr. Dustin Jurries",
      label: "Dr. Dustin Jurries",
    },
    {
      value: "Dr. Kyleigh Drentlaw",
      label: "Dr. Kyleigh Drentlaw",
    },
  ];

  const specialistOption = [
    {
      value: "Cardiology",
      label: "Cardiology",
    },
    {
      value: "Neurology",
      label: "Neurology",
    },
    {
      value: "Gynaecology",
      label: "Gynaecology",
    },
    {
      value: "Ophthalmology",
      label: "Ophthalmology",
    },
    {
      value: "Urology",
      label: "Urology",
    },
  ];

  return (
    <>
      <Modal
        className="add-modal"
        open={open}
        centered
        closable={false}
        onCancel={handleCancel}
        destroyOnClose={true}
        footer={null}
        width={837}
      >
        <div className="modal-content-wrapper">
          <div className="title-header">
            <div className="title">Book an Appointment</div>
            <img src={closeIcon} onClick={() => handleCancel()} />
          </div>
          <hr style={{ margin: "0px " }} />

          {isRegistered ? (
            <div class="form-wrapper">
              <div class="patient-details">
                <div>
                  <span>Patient Name:</span>
                  <span>jane coper</span>
                </div>
                <div>
                  <span>Email:</span>
                  <span>janecoper789@gmail.com</span>
                </div>
                <div>
                  <span>Phone:</span>
                  <span>03457672891</span>
                </div>
              </div>

              <form>
                <div className="registered-title">Select:</div>
                <div class="two-group">
                  <div class="form-group">
                    <label>Specializations</label>
                    <CustomSelect options={specialistOption} />
                  </div>
                  <div class="form-group">
                    <label>Doctor</label>
                    <CustomSelect options={doctors} />
                  </div>
                </div>
                <div class="two-group">
                  <div class="form-group email-group">
                    <label>Date</label>
                    <DatePicker size="large" style={{ width: "100%" }} />
                  </div>
                </div>
                <button type="submit" class="submit-button full-width">
                  Book An Appointment
                </button>
              </form>
            </div>
          ) : (
            <div class="form-wrapper">
              <form onSubmit={handleSubmit}>
                <div class="form-group full-width">
                  <label class="required">Enter KWD ID</label>
                  <input type="text" />
                </div>

                <div class="two-group">
                  <div class="form-group">
                    <label>Patient Name</label>
                    <input type="text" />
                  </div>
                  <div class="form-group">
                    <label>Patient ID no</label>
                    <input type="text" />
                  </div>
                </div>

                <div class="two-group">
                  <div class="form-group">
                    <label>Visit Date</label>
                    <DatePicker size="large" style={{ width: "100%" }} />
                  </div>
                  <div class="form-group">
                    <label>Visit Time</label>
                    <TimePicker size="large" style={{ width: "100%" }} />
                  </div>
                </div>

                <div class="form-group full-width">
                  <label class="required">Location</label>
                  {/* <input type="text" /> */}
                  <Location />
                </div>

                <div class="two-group">
                  <div class="form-group">
                    <label>Specialization</label>
                    <CustomSelect options={specialistOption} />
                  </div>
                  <div class="form-group">
                    <label>Doctor</label>
                    <CustomSelect options={doctors} />
                  </div>
                </div>

                <div class="two-group">
                  <div class="form-group">
                    <label>Date</label>
                    <DatePicker size="large" style={{ width: "100%" }} />
                  </div>
                  <div class="form-group">
                    <label>Time</label>
                  <div className='appointment-time2 d-flex justify-content-between'>
                  <Select
                      // defaultValue="Category Type"
                      style={{
                        width: "80%",
                      }}
                      bordered={true}
                      onChange={() => { }}
                      options={[
                        {
                          label: "9:00 AM",
                          value: "9:00 AM",
                        },
                        {
                          label: "10:00 AM",
                          value: "111:00 AM",
                        },
                        {
                          label: "11:00 AM",
                          value: "11:00 AM",
                        },
                        {
                          label: "12:00 AM",
                          value: "12:00 AM",
                        },
                        {
                          label: "1:00 PM",
                          value: "1:00 PM",
                        },
                        {
                          label: "2:00 PM",
                          value: "2:00 PM",
                        },
                        {
                          label: "3:00 PM",
                          value: "3:00 PM",
                        },
                      ]}
                    />
                    <img className='pr-1' src={ClockIcon} alt="" />
                  </div>
                    {/* <TimePicker size="large" style={{ width: "100%" }} /> */}
                  </div>
                </div>

                <div class="three-group">
                  <div class="form-group">
                    <label>Age</label>
                    <input type="text" id="phone-input" />
                  </div>
                  <div class="form-group">
                    <label for="date-input">Email</label>
                    <input type="text" id="phone-input" />
                  </div>
                  <div class="form-group">
                    <label>Phone no</label>
                    <input type="text" id="phone-input" />
                  </div>
                </div>

                <button type="submit" class="submit-button full-width">
                  Book An Appointment
                </button>
              </form>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default AddAppointmentModal;
